import {ChangeEvent, FC, useEffect, useState} from 'react';
import useSpinnerLoader from '../../../../shared/components/spinner-loader';
import {Button, Table} from 'react-bootstrap';
import {notificationService} from '../../../../shared/services/notification-service';
import {initialResponseData} from "../../../../shared/utils/constants";
import {ReportInOutLeaveService} from "../../../../shared/services/Report/ReportInOutLeave/report-in-out-leave";
import TableHeaderOrdering, {Header} from "../../../../shared/components/table-header-ordering";
import PaginationForm from "../../../../shared/components/molecules/commons/pagination-form";
import TableRowNoData from "../../../../shared/components/molecules/commons/table-row-no-data";
import {AxiosError} from "axios/index";
import {useNavigate} from 'react-router-dom';
import Moment from "moment";
import InputSelect from "../../../../shared/components/atoms/input-select";
import DateRangeInput, { DateRangeInputChange } from '../../../../shared/components/atoms/date-range-input';
import {convertDateToString} from "../../../../shared/utils/functions-date-time";
import {
  fetchDepartmentsOfficeNameOptions,
  fetchDivisionGroupOfficeNameOptions,
  fetchDepartmentsNameOptions,
  fetchPositionNameOptions,

  department_offices_name_Options,
  division_group_office_name_Options, 
  departments_name_Options, 
  position_name_Options, 
} from '../../OptionsDropDown';
import { useAuth } from '../../../../shared/authentications/auth-context';
import { apiEmployeeService } from "../../../../shared/services/employee-service";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Bar, BarChart, XAxis } from 'recharts';

const headers: Header[] = [
  {
    label: 'วันที่',
    field: '',
    order: null,
    isOrder: false,
  },
  {
    label: 'เข้างาน(คน)',
    field: '',
    order: null,
    isOrder: false,
  },
  {
    label: 'ออกงาน(คน)',
    field: '',
    order: null,
    isOrder: false,
  },
  {
    label: 'มาสาย',
    field: '',
    order: null,
    isOrder: false,
  },
  {
    label: 'ลา',
    field: '',
    order: null,
    isOrder: false,
  }
];

const ReportInOutLeaveListPage: FC = () => {
  const { authJwt } = useAuth();
  const isAdmin = authJwt?.role === 'ADMIN';
  const [isUserLoaded, setIsUserLoaded] = useState(false);
 
  const getEmployeeMe = async () => {
    const response = await apiEmployeeService.getEmployeeMe();

    if(response.length !== 0 && !isAdmin) {
      let arr: Array<any> = response.job_positions.filter((v: any) => v.is_currently);
      let division_group_office_name = arr.at(0)?.division_group_office_name || '';
      setIsUserLoaded(true);
      setQueryParams({
        ...queryParams,
        division_group_office_name: division_group_office_name
      });
    } else {
      setIsUserLoaded(true);
      setQueryParams(queryParams);
    }

  }

  useEffect(() => {
    getEmployeeMe()
  }, []);

  //

  // const [data, setData] = useState(initialResponseData);
  const [data, setData] = useState<any>({});
  const [queryParams, setQueryParams] = useState({
    department_offices_name: '',
    division_group_office_name: '',
    structure_departments_name: '',
    position_name: '',
    date_start: '',
    date_end: '',
    page: 1,
    page_size: 10,
    full_date_start: '',
    full_date_end: '',
    displayType: 'month',
    year: parseInt(Moment().format('YYYY'))+543,
    month: String(parseInt(Moment().format('MM'))),
    budgetYear: (() => {
      let y = parseInt(Moment().format('YYYY'))+543;
      if(parseInt(Moment().format('MM')) >= 10) { ++y; }
      return String(y);
    })(),
  });

  const {loaderComponent, startLoading, stopLoading} = useSpinnerLoader();

  const navigate = useNavigate();

  const fetchData = async () => {
    if(!isUserLoaded) { return; }
    startLoading();
    try {
      const result = await ReportInOutLeaveService.getReportInOutLeaveListV2({
        // division_group_office_name: queryParams.division_group_office_name,
        // structure_departments_name: queryParams.structure_departments_name,
        // position_name: queryParams.position_name,
        // date_start: queryParams.date_start,
        // date_end: queryParams.date_end,
        year: queryParams.displayType == 'month' ? queryParams.year-543 : parseInt(queryParams.budgetYear)-543,
        month: queryParams.month,
        display_type: queryParams.displayType,
        full_date_start: queryParams.full_date_start,
        full_date_end: queryParams.full_date_end
        // page: queryParams.page,
        // page_size: queryParams.page_size
      });
      if(queryParams.displayType === 'day') {

        const total = result.rows.reduce((acc: any, row: any) => {
          if (!acc['rows']) {
            acc['rows'] = [{
              absent_count: 0,
              check_out_count: 0, 
              on_time_count: 0,
              late_count: 0,
              leave_count: 0
            }];
          }
          acc['rows'][0].on_time_count += Number(row.on_time_count);
          acc['rows'][0].absent_count += Number(row.absent_count);
          acc['rows'][0].check_out_count += Number(row.check_out_count);
          acc['rows'][0].late_count += Number(row.late_count);
          acc['rows'][0].leave_count += Number(row.leave_count);
          return acc;
        }, {});
      
        setData(total);
      } else {
        setData(result);
      }
    } catch (error) {
      const err = error as AxiosError;
      notificationService.dangerNotification('โหลดข้อมูลไม่สำเร็จ', err.message);
    } finally {
      stopLoading();
    }
  };

  const tableRowNoData = () => {
    if (data.rows?.length === 0) {
      return <TableRowNoData colspan={headers.length}/>;
    }
    return null;
  };

  const onChangePageSize = (page_size: number) => {
    setQueryParams({
      ...queryParams,
      page_size: page_size
    });
  };

  const onChangePage = (page: number) => {
    setQueryParams({
      ...queryParams,
      page: page
    });
  };

  const onChangeDisplayType = (e: ChangeEvent<HTMLSelectElement>) => {
    setQueryParams({
          ...queryParams,
          displayType: e.target.value
      });
  };

  const onChangeMonth = (e: ChangeEvent<HTMLSelectElement>) => {
    setQueryParams({
          ...queryParams,
          month: e.target.value
      });
  };

  const onChangeYear = (e: ChangeEvent<HTMLInputElement>) => {
      setQueryParams({
          ...queryParams,
          year: parseInt(e.target.value)
      });
  };

  const onChangeBudgetYear = (e: ChangeEvent<HTMLInputElement>) => {
    setQueryParams({
        ...queryParams,
        budgetYear: e.target.value
    });
};

  useEffect(() => {
    fetchData();
  },[
    queryParams.department_offices_name,
    queryParams.division_group_office_name,
    queryParams.structure_departments_name,
    queryParams.position_name,
    queryParams.date_start, 
    queryParams.date_end,
    queryParams.page_size, 
    queryParams.page,
    isUserLoaded
  ]);

  useEffect(() => {
    fetchDepartmentsOfficeNameOptions();
    fetchDivisionGroupOfficeNameOptions();
    fetchDepartmentsNameOptions();
    fetchPositionNameOptions();
  }, []);

  const handleDateRangeChange = (value: DateRangeInputChange) => {
    setQueryParams({
      ...queryParams,
      full_date_start: value.startDate ? convertDateToString(value.startDate) : '',
      full_date_end: value.endDate ? convertDateToString(value.endDate) : ''
    });
  };

  const CustomXAxisTick = ({ x, y, payload }: any) => {
    const words = payload.value.split("*");
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={15} textAnchor="middle" fill="#666">
          <tspan x="0" dy="0em">
            {words[0]}
          </tspan>
          <tspan x="0" dy="1.2em">
            {words[1]}
          </tspan>
        </text>
      </g>
    );
  };

  function formatNumber(num: any) {
    if (Math.floor(num) === num) {
      return num.toFixed(0);
    } else {
      return num.toFixed(2);
    }
  }

  const CustomLabel = ({ x, y, width, value, total }: any) => (
    <text x={x + width / 2} y={y - 10} fill="#000" textAnchor="middle">
      <tspan x={x + width / 2} dy="-1.2em">{`${value} คน`}</tspan>
      <tspan x={x + width / 2} dy="1.2em">{`${
        total > 0 ? formatNumber((value * 100) / total) : 0
      } %`}</tspan>
    </text>
  );

  // ================================

  return <div>
    <div className="d-flex justify-content-between py-4">
      <h2 className="text-mof-primary m-0">รายงานสถิติเข้า - ออกงานและการลา</h2>
    </div>

    {loaderComponent}

    <div className="row">
      <div className="col-sm-12 col-md-2">
        <label className="form-label">การแสดงผล</label>
        <select className="form-control" onChange={onChangeDisplayType} name="search" value={queryParams.displayType}>
            <option value="day">รายวัน</option>
            <option value="month">รายเดือน</option>
            <option value="budget-year">ปีงบประมาณ</option>
        </select>
        {/* <input className="form-control" type="text" value={queryParams.month}
                onChange={onChangeMonth} name="search"/> */}
      </div>

      {
        (() => {
          if(queryParams.displayType == 'day') {
            return <>
              <div className="flex-row col-sm-12 col-md-3">
                <label className="form-label">ช่วงวันเริ่มต้น-สิ้นสุด</label>
                <DateRangeInput
            startDate={
              queryParams.full_date_start ? new Date(queryParams.full_date_start) : null
            }
            endDate={
              queryParams.full_date_end ? new Date(queryParams.full_date_end) : null
            }
            onChange={handleDateRangeChange}
            disable={false}
                />
              </div>
            </>;
          }
        })()
      }

      {
        (() => {
          if(queryParams.displayType == 'month') {
            return <>
              <div className="col-sm-12 col-md-2">
                <label className="form-label">เดือน</label>
                <select className="form-control" onChange={onChangeMonth} name="search" value={queryParams.month}>
                    <option value="">-- เลือก --</option>
                    <option value="1">มกราคม</option>
                    <option value="2">กุมภาพันธ์</option>
                    <option value="3">มีนาคม</option>
                    <option value="4">เมษายน</option>
                    <option value="5">พฤษภาคม</option>
                    <option value="6">มิถุนายน</option>
                    <option value="7">กรกฎาคม</option>
                    <option value="8">สิงหาคม</option>
                    <option value="9">กันยายน</option>
                    <option value="10">ตุลาคม</option>
                    <option value="11">พฤศจิกายน</option>
                    <option value="12">ธันวาคม</option>
                </select>
              </div>
              <div className="col-sm-12 col-md-2">
                  <label className="form-label">ปี</label>
                  <input className="form-control" type="text" value={queryParams.year}
                          onChange={onChangeYear} name="search"/>
              </div>
            </>
          }
        })()
      }
      
      {
        (() => {
          if(queryParams.displayType == 'budget-year') {
            return <>
              <div className="col-sm-12 col-md-2">
                <label className="form-label">ปีงบประมาณ</label>
                <input className="form-control" type="text" value={queryParams.budgetYear}
                        onChange={onChangeBudgetYear} name="search"/>
              </div>
            </>;
          }
        })()
      }

      <div className="col-sm-12 col-md-2">
        <div style={{ height: '31px' }}></div>
        <Button variant="primary" type="button" className="d-inline-block px-4" onClick={fetchData}>
            <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
        </Button>
      </div>

    </div>
<br/><br/>

    <div className="d-flex justify-content-between flex-wrap">
        {data.rows?.map((data: any, index: any) => {
          return (
            <div key={index} className="mb-5">
           <div key={index} >
              <h5 className="text-mof-primary m-0">
                ประเภท พนักงาน
              </h5>
              </div>
              <BarChart
                width={600}
                height={400}
                data={[
                  {
                    name: "มา",
                    count: Number(data?.on_time_count) || 0,
                  },
                  {
                    name: "สาย",
                    count: Number(data?.late_count) || 0,
                  },
                  {
                    name: "ขาด",
                    count:
                    Math.abs(Number(data?.absent_count)) || 0,
                  },
                  {
                    name: "ลา",
                    count:
                    Number(data?.leave_count) || 0,
                  },
                ]}
                margin={{
                  top: 70,
                  bottom: 15,
                }}
              >
                <XAxis dataKey="name" tick={<CustomXAxisTick />} />
                <Bar
                  dataKey="count"
                  barSize={50}
                  fill={index % 2 === 0 ? "green" : "red"}
                  label={{
                    position: "top",
                    content: <CustomLabel total={(data.on_time_count || 0) + (data.late_count || 0)} />,
                  }}
                />
              </BarChart>
            </div>
          );
        })}
          </div>
          
  </div>;

  // return <div>
  //   <div className="d-flex justify-content-between py-4">
  //     <h2 className="text-mof-primary m-0">รายงานสถิติเข้า - ออกงานและการลา</h2>
  //   </div>

  //   {loaderComponent}

    

  //   <div className="row">
  //     {
  //       (() => {
  //         if(isAdmin) {
  //           return <>
  //             <div className="flex-row col-sm-12 col-md-3">
  //               <label className="form-label">สำนัก/ฝ่าย</label>
  //               <InputSelect value={queryParams.department_offices_name} options={department_offices_name_Options} placeholder="" name="is_active"
  //                 onChange={(e:any) => {
  //                   setQueryParams(prevState => {
  //                     return {
  //                       ...prevState,
  //                       department_offices_name: e.value.value || ""
  //                     }
  //                   })
  //                 }} 
  //                 required={true}
  //                 isValidateError={false}/>
  //             </div>
  //           </>
  //         }
  //       })()
  //     }
  //     {
  //       (() => {
  //         if(isAdmin) {
  //           return <>
  //           <div className="flex-row col-sm-12 col-md-3">
  //             <label className="form-label">กอง/กลุ่ม</label>
  //             <InputSelect value={queryParams.division_group_office_name} options={division_group_office_name_Options} placeholder="" name="is_active"
  //               onChange={(e:any) => {
  //                 setQueryParams(prevState => {
  //                   return {
  //                     ...prevState,
  //                     division_group_office_name: e.value.value || ""
  //                   }
  //                 })
  //               }} 
  //               required={true}
  //               isValidateError={false}/>
  //           </div>
  //           </>
  //         }
  //       })()
  //     }
  //     <div className="flex-row col-sm-12 col-md-3">
  //       <label className="form-label">แผนก</label>
  //       <InputSelect value={queryParams.structure_departments_name} options={departments_name_Options} placeholder="" name="is_active"
  //         onChange={(e:any) => {
  //           setQueryParams(prevState => {
  //             return {
  //               ...prevState,
  //               structure_departments_name: e.value.value || ""
  //             }
  //           })
  //         }} 
  //         required={true}
  //         isValidateError={false}/>
  //     </div>
  //     <div className="flex-row col-sm-12 col-md-3">
  //       <label className="form-label">ตำแหน่ง</label>
  //       <InputSelect value={queryParams.position_name} options={position_name_Options} placeholder="" name="is_active"
  //         onChange={(e:any) => {
  //           setQueryParams(prevState => {
  //             return {
  //               ...prevState,
  //               position_name: e.value.value || ""
  //             }
  //           })
  //         }} 
  //         required={true}
  //         isValidateError={false}/>
  //     </div>
  //     <div className="flex-row col-sm-12 col-md-3">
  //         <label className="form-label">ช่วงวันเริ่มต้น-สิ้นสุด</label>
  //         <DateRangeInput
  //           startDate={queryParams.date_start ? new Date(queryParams.date_start) : null}
  //           endDate={queryParams.date_end ? new Date(queryParams.date_end) : null}
  //           onChange={handleDateRangeChange}
  //           disable={false}
  //         />
  //     </div>
  //   </div>

  //   <div className="overflow-auto mt-3">
  //     <Table striped bordered hover>
  //       <thead>
  //         <TableHeaderOrdering headers={headers} onChangeOrder={() => {
  //         }} isShow={true}/>
  //       </thead>
  //       <tbody>
  //         {
  //           data.rows?.map((data: any,index) => {
  //             return <tr key={index} style={{cursor: "pointer"}} onClick={() => {
  //               window.location.href = (`report-in-out-leave/${Moment(data.date).utcOffset('+07:00').add(543,'year').format('DD/MM/YYYY').substring(0, 2)}/${Moment(data.date).utcOffset('+07:00').add(543,'year').format('DD/MM/YYYY').substring(3, 5)}/${Moment(data.date).utcOffset('+07:00').add(543,'year').format('DD/MM/YYYY').substring(6, 10)}/details`)
  //             }}>
  //               <td>{data.date ? Moment(data.date).utcOffset('+07:00').add(543,'year').format('DD/MM/YYYY') : '-'}</td>
  //               <td>{data.on_time_count ? data.on_time_count : '-'}</td>
  //               <td>{data.check_out_count ? data.check_out_count : '-'}</td>
  //               <td>{data.late_count ? data.late_count : '-'}</td>
  //               <td>{data.leave_count ? data.leave_count : '-'}</td>
  //             </tr>
  //           })
  //         }
  //         {tableRowNoData()}
  //       </tbody>
  //     </Table>
  //   </div>

  //   <div className="">
  //     <PaginationForm 
  //       current_page={queryParams.page} 
  //       count={data.count} 
  //       page_size={queryParams.page_size}
  //       onChangePageSize={onChangePageSize} 
  //       onChangePage={onChangePage}
  //     />
  //   </div>

  // </div>;
}

export default ReportInOutLeaveListPage;